import { Link } from '@tanstack/react-router'
import { MoonIcon, SunIcon } from '@heroicons/react/20/solid'
import { isSignedIn } from '../../../auth'
import { trackSignUpClick } from '../../../utils/analytics'
import { useTheme } from '../../../hooks/useTheme'
import { localeHomePath, useHomeStrings, useLocale } from '../../../i18n'

export default function Header() {
  const signedIn = isSignedIn()
  const { isDark, toggle } = useTheme()
  const t = useHomeStrings().nav
  const homePath = localeHomePath(useLocale())

  return (
  <header className="bg-background-elevated sticky top-0 z-50 border-b border-border/60">
      <nav className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" aria-label="Top">
        <div className="w-full py-6 flex items-center justify-between gap-4 whitespace-nowrap">
          <div className="flex items-center min-w-0">
            <Link to={homePath} className="flex items-center gap-3 group">
              <span className="sr-only">compress-glb.com</span>
              <svg className="h-8 w-8 text-primary group-hover:text-primary-hover transition-colors duration-200" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="hidden sm:inline text-xl font-semibold text-foreground group-hover:text-accent transition-colors duration-200" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                compress-glb.com
              </span>
            </Link>
            <div className="ml-4 sm:ml-10 flex items-center gap-4 sm:gap-8">
              <Link to={homePath} hash="code-samples" className="text-sm font-medium text-muted-foreground hover:text-foreground hidden lg:inline transition-colors duration-200">
                {t.codeSamples}
              </Link>
              <Link to={homePath} hash="faq" className="text-sm font-medium text-muted-foreground hover:text-foreground hidden lg:inline transition-colors duration-200">
                {t.faq}
              </Link>
              
              <Link 
                to="/blog" 
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors duration-200"
              >
                {t.blog}
              </Link>
              <Link 
                to="/docs" 
                className="text-sm font-medium text-muted-foreground hover:text-foreground border border-border/60 hover:border-border rounded-lg py-1.5 px-3 transition-all duration-200"
              >
                {t.docs}
              </Link>
            </div>
          </div>
          <div className="flex items-center gap-2 sm:gap-4">
            <button
              type="button"
              onClick={toggle}
              aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
              className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border/60 text-muted-foreground hover:text-foreground hover:bg-background-soft hover:border-border transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-accent/50 focus:ring-offset-2"
            >
              {isDark ? (
                <SunIcon className="h-4 w-4" aria-hidden="true" />
              ) : (
                <MoonIcon className="h-4 w-4" aria-hidden="true" />
              )}
            </button>
            <Link
              to={signedIn ? '/app/dashboard' : '/sign-up'}
              className="inline-block border-0 py-2 px-4 rounded-lg text-sm font-medium text-primary-foreground bg-primary hover:bg-primary-hover hover:text-primary-foreground transition-all duration-200 shadow-sm"
              onClick={() => {
                if (!signedIn) {
                  trackSignUpClick('header');
                }
              }}
            >
              {signedIn ? t.dashboard : t.signUp}
            </Link>

            {!signedIn && (
              <Link
                to="/sign-in"
                className="hidden sm:inline-block border-0 py-2 px-4 rounded-lg text-sm font-medium text-primary hover:text-primary-hover transition-all duration-200"
              >
                {t.signIn}
              </Link>
            )}
          </div>
        </div>
      </nav>
    </header>
  )
}

